export default [
  {
    path: 'country',
    name: 'country',
    component: () => import('@/views/pages/country/Country.vue'),
    meta: {
      pageTitle: 'Country',
      breadcrumb: [
        {
          text: 'Country',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
